<template>
  <div v-loading="loading" class="claims-detail">
    <!-- 赔付单基本信息 -->
    <div class="info-section">
      <div class="info-row">
        <div class="info-item">
          <span class="label">状态：</span>
          <span class="value status-tag">
            {{ getStatusText(detail.status) }}
          </span>
        </div>
        <div class="info-item">
          <span class="label">赔付单ID：</span>
          <span class="value">{{ detail.srb_id }}</span>
        </div>
      </div>

      <div class="info-row">
        <div class="info-item">
          <span class="label">商家ID：</span>
          <span class="value">{{ detail.merchant_id }}</span>
        </div>
        <div class="info-item">
          <span class="label">赔付单生成时间：</span>
          <span class="value">{{ detail.created_time }}</span>
        </div>
      </div>

      <div class="info-row">
        <div class="info-item">
          <span class="label">商家名称：</span>
          <span class="value">{{ detail.merchant_name }}</span>
        </div>
        <div class="info-item">
          <span class="label">赔付原因：</span>
          <span class="value">{{ detail.reason }}</span>
        </div>
      </div>

      <div class="info-row">
        <div class="info-item">
          <span class="label">赔付单完成时间：</span>
          <span class="value">{{ detail.complete_time }}</span>
        </div>
      </div>
    </div>

    <!-- 商品明细表格 -->
    <div class="table-section">
      <div class="table-header">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="代采计划ID">
            <el-input
              v-model="searchForm.planid"
              placeholder="代采计划ID"
              clearable
              style="width: 200px; margin-right: 10px"
            />
          </el-form-item>
          <el-form-item label="货号">
            <el-input
              v-model="searchForm.goods_no"
              placeholder="货号"
              clearable
              style="width: 200px; margin-right: 10px"
            />
          </el-form-item>
          <el-form-item label="款号">
            <el-input
              v-model="searchForm.goods_kh"
              placeholder="款号"
              clearable
              style="width: 200px; margin-right: 10px"
            />
          </el-form-item>
          <el-form-item label="SKU编码">
            <el-input
              v-model="searchForm.sku"
              placeholder="SKU编码"
              clearable
              style="width: 200px; margin-right: 10px"
            />
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form>

        <!-- 添加统计信息和整单作废按钮 -->
        <div class="table-summary">
          <div class="summary-info">
            有效商品共 <span class="highlight">{{ kh_num }}</span> 款，
            <span class="highlight">{{ goods_num }}</span> 件， 赔付总金额
            <span class="highlight">¥{{ total_price }}</span>
          </div>
          <div class="operation-buttons">
            <el-button
              type="danger"
              size="small"
              :disabled="!hasValidItemsToCancel"
              @click="handleBatchCancel"
            >
              整单作废
            </el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="demanded_datetime"
          label="商家履约需求开始日期"
          width="180"
        />
        <el-table-column
          prop="delivery_day_text"
          label="承诺货期"
          width="120"
        />
        <el-table-column
          prop="delivery_datetime"
          label="承诺发货日期"
          width="180"
        />
        <el-table-column prop="planid" label="代采计划ID" width="120" />
        <el-table-column
          prop="plan_create_datetime"
          label="代采计划生成时间"
          width="180"
        />

        <!-- 仅"货期超时"原因显示 -->
        <el-table-column
          v-if="detail.reason === '货期超时'"
          prop="blp_in_datetime"
          label="不良品入库时间"
          width="180"
        />
        <el-table-column
          v-if="detail.reason === '货期超时'"
          prop="stock_in_datetime"
          label="良品入库时间"
          width="180"
        />

        <!-- 仅"缺货断货"原因显示 -->
        <el-table-column
          v-if="detail.reason === '缺货断货'"
          prop="cancel_datetime"
          label="断货时间"
          width="180"
        >
          <template #default="scope">
            <span>{{ scope.row.cancel_datetime || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="detail.reason === '缺货断货'"
          prop="cancel_user"
          label="断货人"
          width="120"
        >
          <template #default="scope">
            <span>{{ scope.row.cancel_user || "系统" }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="goods_no" label="货号" width="120" />
        <el-table-column prop="goods_kh" label="款号" width="120" />
        <el-table-column prop="sku" label="SKU编码" width="120" />
        <el-table-column prop="co_val" label="颜色" width="100" />
        <el-table-column prop="si_val" label="尺码" width="100" />
        <el-table-column prop="plan_price" label="拿货单价" width="120">
          <template #default="scope">
            {{ formatAmount(scope.row.plan_price) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="slow_compensation_rate_text"
          label="赔付比例"
          width="120"
        >
          <template #default="scope">
            {{ scope.row.slow_compensation_rate_text || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="slow_compensation_price"
          label="赔付金额"
          width="120"
        >
          <template #default="scope">
            {{ formatAmount(scope.row.slow_compensation_price) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120" align="center">
          <template #default="{ row }">
            <el-button
              v-if="!row.is_created"
              type="text"
              size="small"
              @click="handleCreate(row, false)"
            >
              作废
            </el-button>
            <span v-else class="created-text">
              已作废<br />
              {{ row.void_admin_name }}<br />
              {{ row.void_datetime }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 作废确认弹窗 -->
    <el-dialog
      :title="cancelDialogTitle"
      :visible.sync="cancelDialogVisible"
      width="400px"
    >
      <div class="cancel-dialog-content">
        <p>{{ cancelDialogMessage }}</p>
        <p class="warning-text">
          作废后不能恢复，且该商品不会被同样原因生成赔付单
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmCancel">确认作废</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  postGetInfoData,
  postCancelById,
} from "@/openapi/erp/slowCompensation.js";

export default {
  name: "MerchantClaimsDetail",
  data() {
    return {
      loading: false,
      detail: {},
      searchForm: {
        planid: "",
        goods_kh: "",
        goods_no: "",
        sku: "",
        id: "",
      },
      kh_num: 0,
      goods_num: 0,
      total_price: 0,
      tableData: [],
      // 新增作废相关数据
      cancelDialogVisible: false,
      cancelDialogTitle: "作废确认",
      cancelDialogMessage: "",
      currentCancelItem: null,
      isBatchCancel: false,
    };
  },
  computed: {
    // 计算是否有可作废的商品
    hasValidItemsToCancel() {
      return this.tableData.some((item) => !item.is_created);
    },
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      try {
        const { id } = this.$route.query;
        console.log("获取详情，ID:", id);

        if (!id) {
          this.$message.error("缺少赔付单ID参数");
          return;
        }

        // 修正参数名称
        const params = {
          id,
          planid: this.searchForm.planid || undefined,
          goods_kh: this.searchForm.goods_kh || undefined,
          goods_no: this.searchForm.goods_no || undefined,
          sku: this.searchForm.sku || undefined,
        };

        console.log("请求参数:", params);
        const res = await postGetInfoData(params);
        console.log("赔付单详情接口返回:", res);

        if (res) {
          // 处理基本信息 - 从master字段获取
          const master = res.master || {};
          this.detail = {
            srb_id: master.id,
            merchant_id: master.supply_id,
            merchant_name: master.supply_name,
            created_time: master.created_datetime,
            complete_time: master.complete_datetime,
            reason: master.type_text,
            status: master.status,
          };

          this.kh_num = res.kh_num;
          this.goods_num = res.goods_num;
          this.total_price = res.total_price;
          // 处理商品列表数据 - 从list字段获取
          this.tableData = (res.list || []).map((item) => ({
            demanded_datetime: item.demanded_datetime,
            delivery_day_text: item.delivery_day_text,
            delivery_datetime: item.delivery_datetime,
            planid: item.planid,
            plan_create_datetime: item.plan_create_datetime,
            blp_in_datetime: item.blp_in_datetime,
            stock_in_datetime: item.stock_in_datetime,
            cancel_datetime: item.cancel_datetime,
            cancel_user: item.cancel_user,
            goods_no: item.goods_no,
            goods_kh: item.goods_kh,
            sku: item.sku,
            co_val: item.co_val,
            si_val: item.si_val,
            plan_price: item.plan_price,
            slow_compensation_rate_text: item.slow_compensation_rate_text,
            slow_compensation_price: item.slow_compensation_price,
            id: item.id,
            is_created: item.void_time && item.void_time !== "0",
            ssc_id: item.ssc_id,
            sscd_id: item.sscd_id,
            void_admin_name: item.void_admin_name,
            void_datetime: item.void_datetime,
          }));
        } else {
          this.$message.warning("未获取到详情数据");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error(error.message || "获取详情失败");
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.fetchDetail();
    },
    handleCreate(row, isBatch = false) {
      this.currentCancelItem = row;
      this.isBatchCancel = isBatch;

      if (isBatch) {
        // 整单作废
        const validItems = this.tableData.filter((item) => !item.is_created);
        this.cancelDialogTitle = "整单作废确认";
        this.cancelDialogMessage = `作废${validItems.length}件赔付单商品。`;
      } else {
        // 单个作废
        this.cancelDialogTitle = "作废确认";
        this.cancelDialogMessage = "作废1件赔付单商品。";
      }

      this.cancelDialogVisible = true;
    },
    handleBatchCancel() {
      this.handleCreate(null, true);
    },
    async confirmCancel() {
      this.cancelDialogVisible = false;
      this.loading = true;

      try {
        if (this.isBatchCancel) {
          // 整单作废
          const validItems = this.tableData.filter((item) => !item.is_created);
          if (validItems.length === 0) {
            this.$message.warning("没有可作废的商品");
            return;
          }

          const params = {
            ssc_id: validItems[0].ssc_id, // 使用第一个商品的赔付单ID
            is_all: "1", // 整单作废标识
          };

          const res = await postCancelById(params);
          if (res) {
            this.$message.success(`成功作废${validItems.length}件商品`);
            this.fetchDetail(); // 刷新数据
          } else {
            throw new Error(res?.msg || "作废失败");
          }
        } else {
          // 单个作废
          if (
            !this.currentCancelItem ||
            !this.currentCancelItem.ssc_id ||
            !this.currentCancelItem.sscd_id
          ) {
            this.$message.error("缺少必要的作废参数");
            return;
          }

          const params = {
            ssc_id: this.currentCancelItem.ssc_id, // 赔付单ID
            sscd_id: this.currentCancelItem.sscd_id, // 赔付单详情ID
            is_all: "0", // 单个作废标识
          };

          const res = await postCancelById(params);
          if (res) {
            this.$message.success("作废成功");
            this.fetchDetail(); // 刷新数据
          } else {
            throw new Error(res?.msg || "作废失败");
          }
        }
      } catch (error) {
        console.error("作废失败:", error);
        this.$message.error(error.message || "作废失败");
      } finally {
        this.loading = false;
      }
    },
    formatAmount(amount) {
      if (!amount && amount !== 0) return "0.00";
      return Number(amount).toFixed(2);
    },

    getStatusText(status) {
      // 根据状态码返回相应的文本
      switch (Number(status)) {
        case 1:
          return "待赔付";
        case 2:
          return "已完成";
        case 3:
          return "已作废";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.claims-detail {
  padding: 20px;

  .info-section {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;

    .info-row {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-item {
        flex: 1;
        display: flex;
        align-items: center;

        .label {
          color: #666;
        }

        .value {
          color: #333;
        }
      }
    }
  }

  .table-section {
    background: #fff;
    padding: 20px;
    border-radius: 4px;

    .table-header {
      margin-bottom: 20px;
    }

    // 新增样式
    .table-summary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0;
      padding: 0 10px;
      background-color: #f8f8f8;
      border-radius: 4px;

      .summary-info {
        font-size: 14px;
        color: #606266;

        .highlight {
          color: #409eff;
          font-weight: bold;
          margin: 0 3px;
        }
      }
    }
  }

  .operation-buttons {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }

  .cancel-dialog-content {
    text-align: center;
    padding: 10px 0;

    .warning-text {
      color: #f56c6c;
      font-size: 14px;
      margin-top: 10px;
    }
  }

  .created-text {
    color: #999;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantClaimsOrder/detail.vue